<div class="row" *ngIf="pwaService.promptEvent && !pwaService.isInstalled">
  <div class="col">
    <div class="px-2">
      <button  (click)="installPwa()" class="btn btn-outline-primary btn-block">
        <i class="app-icon"></i> Pin to Home page
      </button>
    </div>
  </div>
</div>
